<template>
  <div>
    <h2 class="mb-4 text-left font-weight-bold">Checklists</h2>
    <b-row class="wiki-main-wrap">
      <div class="tags-main-wrap">
        <section class="widget">
          <div class="text-center">
            <router-link :to="{ path: `/app/checklists/`}">
              <button type="button" class="btn mr-xs btn-success new-page-btn">
                View All Checklists
              </button>
            </router-link>
          </div>
          <div class="text-center">
            <button type="button" class="btn mr-xs btn-success new-page-btn" @click="gotoCreatePage()">
              <i class="fa fa-plus" aria-hidden="true"></i>Create a Checklist
            </button>
          </div>          
        </section>
      </div>
      <div class="table-main-wrap">
        <section class="widget">
          <b-row>
            <b-col sm="12">
              <h5 data-v-6d85d69b class="text-tagnew font-semibold mt-3 mb-4">Create a Checklist :</h5>
              <ErrorDisplay/>
              <b-form class="routine-form">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-text slot="prepend" class="bg-transparent">
                      <i class="fa fa-list-alt" />&nbsp; <span>Checklist Name</span>
                    </b-input-group-text>
                    <b-form-input v-model="checklistName" placeholder="Enter your Checklist name here. i.e Closing Checklist or FrontDesk daily checklist"/>
                  </b-input-group>
                </b-form-group>
              </b-form>
              <div class="d-flex align-items-center justify-content-between edit-access-mob">
                <div class="d-flex align-items-center edit-access-mob1">                  
                </div>                
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm-12>
              <CustomEditor :editorData="initData" :editorTools="editorTools" @save="save"></CustomEditor>              
            </b-col>
          </b-row>
        </section>
      </div>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable */

import ErrorDisplay from "@/components/ErrorDisplay/ErrorDisplay";
import CustomEditor from "@/components/Editor/Editor.vue";
import { mapState, mapActions, mapMutations } from 'vuex';
import mixin from '../../mixin.js';
import moment from 'moment-timezone';
import _ from 'lodash';

export default {
  name: "CreateChecklist",
  components: { CustomEditor, ErrorDisplay },
  props: ['pages'],
  mixins: [mixin],

  async created() {
  },

  async mounted() {
    await this.init();
  },

  data() {
    return {        
        checklistName: '',
        initData: {
        // time: 1554508385558,
        blocks: [
          {
            type: "checklist",
            data: { 
              "items": [
                {
                  "text": "Add your task here and press enter",
                  "checked": false
                }
              ]
            }
          }
        ]
      },
      editorTools: {
        checklist: {
          class: "Checklist",
          inlineToolbar: true
        }
      }
    }
  },

  methods: {
    ...mapActions('checklists', ['createChecklist']),

    async init() {
    },

    async save(e) {
      if(this.checklistName === '') {
        this.setErrored(true);
        this.setMessage('Please enter a name for your checklist before saving');
        return;
      }

      //console.log('saving checklist:' + JSON.stringify(e));

      let payload = {
        SiteID: this.siteID,
        Name: this.checklistName,
        Content: JSON.stringify(e),        
        CreatedByEmployeeID: this.userID,
        CreatedAt: moment().utc().format('YYYY-MM-DDTHH:mm:ss'),
      };
      //console.log('payload:' + JSON.stringify(payload));
      try {
        await this.createChecklist(payload);
        this.$router.push({name: 'Checklists'});
      } catch (err) {
        this.setErrored(true);
        this.setMessage(`Error while saving a checklist: ${err}`);
      }
    },
    onReady: () => {},
    onChange: () => {},
    gotoCreatePage() {
        this.$router.push('/app/create-checklist');
    }
  },  

  computed: {
  }
};
</script>
